import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { defineComponent as $, computed as k, h as t } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function d(e, p, i = 100) {
  return `m ${i / 2} ${i / 2 - e} a ${e} ${e} 0 1 1 0 ${2 * e} a ${e} ${e} 0 1 1 0 -${2 * e}`;
}
const w = $({
  name: "ProgressMultipleCircle",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    viewBoxWidth: {
      type: Number,
      required: !0
    },
    percentage: {
      type: Array,
      default: [0]
    },
    strokeWidth: {
      type: Number,
      required: !0
    },
    circleGap: {
      type: Number,
      required: !0
    },
    showIndicator: {
      type: Boolean,
      required: !0
    },
    fillColor: {
      type: Array,
      default: () => []
    },
    railColor: {
      type: Array,
      default: () => []
    },
    railStyle: {
      type: Array,
      default: () => []
    }
  },
  setup(e, {
    slots: p
  }) {
    const i = k(() => e.percentage.map((o, l) => `${Math.PI * o / 100 * (e.viewBoxWidth / 2 - e.strokeWidth / 2 * (1 + 2 * l) - e.circleGap * l) * 2}, ${e.viewBoxWidth * 8}`)), y = (s, o) => {
      const l = e.fillColor[o], u = typeof l == "object" ? l.stops[0] : "", c = typeof l == "object" ? l.stops[1] : "";
      return typeof e.fillColor[o] == "object" && t("linearGradient", {
        id: `gradient-${o}`,
        x1: "100%",
        y1: "0%",
        x2: "0%",
        y2: "100%"
      }, t("stop", {
        offset: "0%",
        "stop-color": u
      }), t("stop", {
        offset: "100%",
        "stop-color": c
      }));
    };
    return () => {
      const {
        viewBoxWidth: s,
        strokeWidth: o,
        circleGap: l,
        showIndicator: u,
        fillColor: c,
        railColor: h,
        railStyle: g,
        percentage: f,
        clsPrefix: a
      } = e;
      return t("div", {
        class: `${a}-progress-content`,
        role: "none"
      }, t("div", {
        class: `${a}-progress-graph`,
        "aria-hidden": !0
      }, t("div", {
        class: `${a}-progress-graph-circle`
      }, t("svg", {
        viewBox: `0 0 ${s} ${s}`
      }, t("defs", null, f.map((n, r) => y(n, r))), f.map((n, r) => t("g", {
        key: r
      }, t("path", {
        class: `${a}-progress-graph-circle-rail`,
        d: d(s / 2 - o / 2 * (1 + 2 * r) - l * r, o, s),
        "stroke-width": o,
        "stroke-linecap": "round",
        fill: "none",
        style: [{
          strokeDashoffset: 0,
          stroke: h[r]
        }, g[r]]
      }), t("path", {
        class: [`${a}-progress-graph-circle-fill`, n === 0 && `${a}-progress-graph-circle-fill--empty`],
        d: d(s / 2 - o / 2 * (1 + 2 * r) - l * r, o, s),
        "stroke-width": o,
        "stroke-linecap": "round",
        fill: "none",
        style: {
          strokeDasharray: i.value[r],
          strokeDashoffset: 0,
          stroke: typeof c[r] == "object" ? `url(#gradient-${r})` : c[r]
        }
      })))))), u && p.default ? t("div", null, t("div", {
        class: `${a}-progress-text`
      }, p.default())) : null);
    };
  }
});
export {
  w as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/progress/src/MultipleCircle.js
// module id = 1731
// module chunks = 67